import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import globalText from "../../../../utils/globalText";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";

const BeneficiaryTransactionFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { beneficiaryTransactionsCreateError } = useSelector(
    (state) => state.beneficiaryTransactions,
  );

  const sessionError = sessionStorage.getItem("beneficiaryTxnCreateErrors");

  const parsedSessionError = sessionError ? JSON.parse(sessionError) : null;

  const errorSource =
    parsedSessionError ||
    beneficiaryTransactionsCreateError?.data?.errors ||
    {};

  const errorMessages = Object.values(errorSource).flatMap((value) =>
    Array.isArray(value) ? value : [],
  );

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        imgColor: "var(--negative-bg)",
        handleFunction: () => {
          sessionStorage.removeItem("beneficiaryTxnCreateErrors");
          navigate(
            "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
            { replace: true },
          );
        },
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => {
          sessionStorage.removeItem("beneficiaryTxnCreateErrors");
          navigate("/beneficiary_transaction_dashboard", { replace: true });
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(disableSwitcher());
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="error"
      title={"Failed to create beneficiary transaction."}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection title="Error details">
        <>
          {errorMessages.map((error, index) => (
            <InfoCard
              key={index}
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle: error,
                  leftSubTitle: "Error message",
                },
              ]}
            />
          ))}
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default BeneficiaryTransactionFailed;
